<div class="selected-tags mt-2">
  <!-- Affichage des filtres multiples -->
  @for (filterKey of multipleFilterKeys; track filterKey) {
    @for (option of selectedMultipleFilters[filterKey]; track option) {
        <div class="bg-primary tag" style="width: fit-content" (click)="removeSelection(filterKey, option)">
          <span>{{ option.attributes.name }}</span>
          <span style="margin-left: 8px">&times;</span>
        </div>
      }
    }

    <!-- Affichage des filtres uniques -->
    @for (filterKey of singleFilterKeys; track filterKey) {
      @if (selectedSingleFilters[filterKey]) {
        <div class="bg-primary tag" style="width: fit-content" (click)="removeSelection(filterKey, selectedSingleFilters[filterKey]!)">
          <span>{{ selectedSingleFilters[filterKey]?.name }}</span>
          <span style="margin-left: 8px">&times;</span>
        </div>
        }
      }
    </div>
